import store from '@/store'
import { createI18n } from 'vue-i18n'
import messages from '@intlify/vite-plugin-vue-i18n/messages'

import elementLocaleZhCN from 'element-plus/es/locale/lang/zh-cn'
import elementLocaleEn from 'element-plus/es/locale/lang/en'

function useI18n(app) {
    // 如果没设置默认语言，默认使用英文
    if (!store.state.settings.defaultLang) {
        store.commit('settings/setDefaultLang', 'en')
    }
    // 确保初始化时 Accept-Language 请求头与当前语言一致（修复页面英文但请求头仍为中文的问题）
    store.commit('settings/setDefaultLang', store.state.settings.defaultLang)
    const i18n = createI18n({
        legacy: true,
        allowComposition: true,
        locale: store.state.settings.defaultLang,
        fallbackLocale: 'en',
        messages
    })
    app.use(i18n)
}

function getElementLocales() {
    let locales = {}
    for (const key in messages) {
        locales[key] = {}
        switch (key) {
            case 'zh-cn':
                Object.assign(locales[key], elementLocaleZhCN, { 'labelName': '中文(简体)' })
                break
            case 'en':
                Object.assign(locales[key], elementLocaleEn, { 'labelName': 'English' })
                break
        }
    }
    return locales
}

export {
    useI18n,
    getElementLocales
}
